// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m63G","icon":"styles_icon__2E7L2"};